export default {
  id: 'ショップ ID',
  install_pixel: 'ピクセルをインストールする',
  meta_tag: 'メタタグ',
  manual_installation: ' 手動インストール',
  install_google_tag: 'GOOGLEタグをインストールする',
  login_url: 'ログインURL',
  corporate_url: '貴社サイトURL'
};
